import React, {useEffect, useState, useRef} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setHeader } from '../../store/settings/settingsSlice';
import style from "./virtual-cards.module.css";
import emptyVCImg from '../../assets/images/Group 2073.svg'
import addCircleIcon from '../../assets/images/add-circle-icon.svg'
import ng_icon from '../../assets/images/ng.svg'
import us_icon from '../../assets/images/us.svg'
import ghana_icon from '../../assets/images/ghanaflag.svg'
import eye_icon from '../../assets/images/eye.svg'
import transactionTypeIcon from '../../assets/images/typeIcon.svg'
import moneyIcon from '../../assets/images/moneys.svg'
import arrow_left from '../../assets/images/arrow-left.svg'
// import IconTrailing from '../../assets/images/Icon - Trailing.svg'
import { Icon } from "@iconify/react";
import moment from "moment";
import lock_icon from '../../assets/images/Lock.svg'
import info_icon from '../../assets/images/info_icon.svg'
import spin_circle from '../../assets/images/Loader anim.png'
import mastercard_icon from '../../assets/images/mastercard.svg'
import visa_icon from '../../assets/images/visa.svg'
import logo from '../../assets/images/Astron-01.png'
import successIcon from '../../assets/images/success-icon.svg'
import { Receive, WalletAdd, WalletAdd1, ArrowDown2 } from "iconsax-react";
import { useNavigate } from 'react-router-dom';
import Lottie from "lottie-react";
import loader from "../../assets/lottie/loader.json";
import Modal from '../modal/Modal';
import { createVirtualCard, fetchCardTransactions, freezeVirtualCard, fundVirtualCard, getCardsByID, getCardsByUser, unFreezeVirtualCard, withdrawFromVirtualCard } from '../../store/cards/cardActions';
import { createWallet, fetchExchangeConfig, fetchVirtualCardFees, getWalletBalance } from '../../store/wallet/walletActions';
import Pagination from '../Pagination/Pagination';


const VirtualCardsPage = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const cards = useSelector((state) => state.cards.cards);
    const card = useSelector((state) => state.cards.card);
    const [hasUSDWallet, setHasUSDWallet] = useState(false);
    const [usdCurrencyId, setUsdCurrencyId] = useState(null); // to use for creating wallet
    const transactions = useSelector((state) => state.cards.transactions);
    const transactionsTotal = useSelector((state) => state.cards.transactionsTotal);
    const isLoading = useSelector((state) => state.cards.isLoading);
    const myLevel = useSelector((state) => state.userKyc.kycStats.userkyc)
    const walletData = useSelector((state) => state.wallet.data);
    const exchangeConfig = useSelector((state) => state.wallet.exchangeConfig);
    const fees = useSelector((state) => state.wallet.virtualFees);
    const fiatCurrencies = useSelector((state) => state.wallet.fiatCurrencies.data ? state.wallet.fiatCurrencies.data.fiat : "");
    const [isRequestCardModal, setRequestCardModal] = useState(false);
    const [isFreezeCardModal, setFreezeCardModal] = useState(false);
    const [isCreateCardModal, setCreateCardModal] = useState(false);
    const [isFundCardModal, setFundCardModal] = useState(false);
    const [isWithdrawModal, setWithdrawModal] = useState(false);
    const [initiateLoader, setInitiateLoader] = useState(false);
    const [isInitiated, setIsInitiated] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isCardRequestedModal, setCardRequestedModal] = useState(false);
    const [isFreezeCardSuccessModal, setFreezeCardSuccessModal] = useState(false);
    const [isVirtualFundingSuccessModal, setVirtualFundingSuccessModal] = useState(false);
    const [isWithdrawSuccessModal, setWithdrawSuccessModal] = useState(false);
    const [visible, setVisible] = useState(true);
    const [isOn, setIsOn] = useState(false);
    const [userCards, setUserCards] = useState([]);
    const [activeCard, setActiveCard] = useState(null);
    const [centerIndex, setCenterIndex] = useState(1); // Update initial center card to 0
    const [flippedCardId, setFlippedCardId] = useState(null);
     const [type, setType] = useState("");
    const [cardType, setCardType] = useState("");
    const [openCardType, setOpenCardType] = useState(false);
    const [amount, setAmount] = useState(0);
    const [openFromWallet, setOpenFromWallet] = useState(false);
    const [openToWallet, setOpenToWallet] = useState(false);
    const [sourceWallet, setSourceWallet] = useState("");
    const [destinationWallet, setDestinationWallet] = useState("");
    const [exchangeRate, setExchangeRate] = useState(0);
    const [receiveAmount, setReceiveAmount] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    let PageSize = 100;
    const [currentPage, setCurrentPage] = useState(1);
    const transactionsRef = useRef(null);

     // Add this scroll handler
     const scrollToTransactions = () => {
         transactionsRef.current?.scrollIntoView({ 
             behavior: 'smooth',
             block: 'start'
         });
     };
 
    

    const cardTypes = [
        { id: 1, name: 'MASTERCARD' },
        { id: 2, name: 'VISA' },
    ]

       // Format number with commas
       const formatNumberWithCommas = (value) =>
        new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);

      const formatKoboToNaira = (kobo) => {
        if (!kobo) return '0.00';
        // Convert kobo to naira by dividing by 100 and format to 2 decimal places
        return (parseFloat(kobo) / 100).toFixed(2);
    };


    const formatExchangeRateDisplay = (rate, source, destination) => {
        // If rate is less than 1, flip the display
        if (rate < 1) {
          // Calculate how many source currency units equal 1 destination unit
          const sourcePerDestination = 1 / rate;
          return {
            from: destination,
            to: source,
            baseAmount: 1,
            rate: sourcePerDestination.toFixed(2)
          };
        }
        
        return {
          from: source,
          to: destination,
          baseAmount: 1,
          rate: rate.toFixed(2)
        };
      };

    
    const toggleCardType = () => {
        setOpenCardType((prevCardType) => {
          if (prevCardType === false) {
            return true;
          } else if (prevCardType === true) {
            return false;
          }
        });
      };


    // HANDLE ACCOUNT CLOSE ON CLICK OUT
    useEffect(() => {
        let handler = (e) => {
        if (e.target.id !== "cardType") {
            setOpenCardType(false);
        } else if (e.target.id === "cardType") {
            toggleCardType();
        }
        if (e.target.id === "cardTypeDrop") {
            setOpenCardType(true);
        }
        // console.log(currRef.current.name)
        };
        document.addEventListener("mousedown", handler);
    
        return () => {
        document.removeEventListener("mousedown", handler);
        };
    }, []);


    const toggleFromWallet = () => {
        setOpenFromWallet(!openFromWallet)
    };

    const toggleToWallet = () =>{
        setOpenToWallet(!openToWallet)
    }

    const resetFormValues = () => {
        setAmount(0);
        setSourceWallet("");
        setDestinationWallet("");
        setReceiveAmount("");
        setErrorMessage("");
        setExchangeRate(0);
        setIsInitiated(false);
        setCardType(""); // for Add New Card only
    };

    const handleCloseCreateCardModal = () => {
        resetFormValues();
        setCreateCardModal(false);
    };

    const handleCloseFundModal = () => {
        resetFormValues();
        setFundCardModal(false);
    };
    
    const handleCloseWithdrawModal = () => {
        resetFormValues();
        setWithdrawModal(false);
    };

    
    const handleFromWallet = (e) => {
        const selectedCurrency = e.target.textContent;
         setOpenFromWallet(false);
         setSourceWallet(selectedCurrency);
         setDestinationWallet("USD");
         setAmount(0);
         setReceiveAmount("");
         setExchangeRate(0);
         setErrorMessage("");
    }

    const handleToWallet = (e) => {
        const selectedCurrency = e.target.textContent;
        setOpenToWallet(false);
        setDestinationWallet(selectedCurrency);
        setSourceWallet("USD")
        setAmount(0);
        setReceiveAmount("");
        setExchangeRate(0);
        setErrorMessage("");
    }

    const handleAmountChange = (e) => {
        const inputAmount = e.target.value;
        setAmount(inputAmount);
        setDestinationWallet("USD")

        
        if (!sourceWallet || !destinationWallet) {
          setErrorMessage("Please select a source wallet.");
          setReceiveAmount("");
          return;
        }
    
        setErrorMessage("");

         // If source and destination wallets are the same currency (USD to USD)
         if (sourceWallet === destinationWallet) {
            setExchangeRate(1);
            setReceiveAmount(
                inputAmount && !isNaN(inputAmount)
                    ? formatNumberWithCommas(inputAmount)
                    : "0"
            );
            return;
        }
    
        // Filter exchange rates based on selected wallets
        const exchangeRateData = exchangeConfig.find(
          (rate) =>
            rate.BaseCurrency.code === sourceWallet && rate.TargetCurrency.code === destinationWallet
        );
    
        if (exchangeRateData) {
          const exchangeRate = parseFloat(exchangeRateData.exchange_rate);
          setExchangeRate(exchangeRate)
          const calculatedReceiveAmount = parseFloat(inputAmount) * parseFloat(exchangeRate);
          // setReceiveAmount(calculatedReceiveAmount.toFixed(2)); // Round to 2 decimal places
          setReceiveAmount(
            inputAmount && !isNaN(calculatedReceiveAmount)
              ? formatNumberWithCommas(calculatedReceiveAmount)
              : "0"
          );
        } else {
          setErrorMessage("Exchange rate not found for the selected currencies.");
          setReceiveAmount("");
        }
    };

    const handleWithdrawAmountChange = (e) => {
        const inputAmount = e.target.value;
        setAmount(inputAmount);
    
        if (!sourceWallet || !destinationWallet) {
          setErrorMessage("Please select a destination wallet.");
          setReceiveAmount("");
          return;
        }
    
        setErrorMessage("");


        // If source and destination wallets are the same currency (USD to USD)
        if (sourceWallet === destinationWallet) {
            setExchangeRate(1);
            setReceiveAmount(
                inputAmount && !isNaN(inputAmount)
                    ? formatNumberWithCommas(inputAmount)
                    : "0"
            );
            return;
        }
    
        // Filter exchange rates based on selected wallets
        const exchangeRateData = exchangeConfig.find(
          (rate) =>
            rate.BaseCurrency.code === sourceWallet && rate.TargetCurrency.code === destinationWallet
        );
    
        if (exchangeRateData) {
          const exchangeRate = parseFloat(exchangeRateData.exchange_rate);
          setExchangeRate(exchangeRate)
          const calculatedReceiveAmount = parseFloat(inputAmount) * parseFloat(exchangeRate);
          // setReceiveAmount(calculatedReceiveAmount.toFixed(2)); // Round to 2 decimal places
          setReceiveAmount(
            inputAmount && !isNaN(calculatedReceiveAmount)
              ? formatNumberWithCommas(calculatedReceiveAmount)
              : "0"
          );
        } else {
          setErrorMessage("Exchange rate not found for the selected currencies.");
          setReceiveAmount("");
        }
    };

   
    useEffect(() => {
        setUserCards(cards);
        // Set the initial active card based on centerIndex
        if (cards && cards.length > 0) {
            // If only one card, use index 0, otherwise use centerIndex
            const activeIndex = cards.length === 1 ? 0 : centerIndex;
            setActiveCard(cards[activeIndex]);
             // Set isOn based on card's DISABLED status
           setIsOn(cards[activeIndex].status === "DISABLED");

            dispatch(getCardsByID({
                cardId: cards[activeIndex].id
            }))
            dispatch(fetchCardTransactions({
                cardId: cards[activeIndex].id,
                page: 1
            }))
        }
    }, [cards, centerIndex, dispatch]);

    const getCardPositionClass = (index) => {
        if (userCards.length === 1) return 'center'; // Always center when one card
        if (index === centerIndex) return 'center';
        if (index < centerIndex) return 'left';
        return 'right';
      };


    const handleCardClick = (index) => {
        // Prevent switching if only one card exists
        if (userCards.length === 1) return;
      
        // Prevent switching if the clicked card is already the center
        if (index === centerIndex) return;

          // Find the clicked card
            const clickedCard = userCards[index];
            
            // Set the active card
            setActiveCard(clickedCard);

            // Update isOn based on clicked card's DISABLED status
            setIsOn(clickedCard.status === "DISABLED");
      
        // Swap the clicked card with the center card
        const newCards = [...userCards];
        const temp = newCards[centerIndex];
        newCards[centerIndex] = newCards[index];
        newCards[index] = temp;
      
        setUserCards(newCards);
        setCenterIndex(centerIndex); 
          // Make API call to get card details by ID
            dispatch(getCardsByID({
                cardId: clickedCard.id
            }));
            dispatch(fetchCardTransactions({
                cardId: clickedCard.id,
                page: currentPage
            }))
      };
      
  
    const toggleFlip = (id) => {
      setFlippedCardId((prevId) => (prevId === id ? null : id));
    };

    const handleUpgrade = () =>{
        setRequestCardModal(false)
        navigate('/settings')
    }

    const handleRequestCheck = () =>{
        resetFormValues();
        if(myLevel && myLevel.kyc_setting_id < 4){
            setRequestCardModal(true)
        }
        else {
            setCreateCardModal(true)
        }
    }

     const formatLoaderTitle = (title) => {
        let res;
        switch(title){
            case "fund":
               res = "Funding Card"
                break;
            case "withdraw":
               res = "Initiating Withdrawal"
                break;
            case "request":
                res = "Requesting Virtual Card"
                break;
            case "freeze":
                res = "Freezing Card"
                break;
            case "unfreeze":
                res = "Unfreezing Card"
                break;
            default:
                break;
        }
      return res;
     }

    const handleFreezeModal = () =>{
        if(isOn){
            setType("unfreeze")
           setFreezeCardModal(true)
        }
        else {
            setType("freeze")
            setFreezeCardModal(true)
        }
    }

    const handleFreezeCard = () =>{
        setFreezeCardModal(false)
        setIsOpen(true)
        if(isOn){
            dispatch(unFreezeVirtualCard({
                cardId: activeCard.id
            })).then((res)=>{
                if(res?.type === "unFreezeVirtualCard/fulfilled"){
                    setIsOpen(false)
                    setIsOn(!isOn)
                    setFreezeCardSuccessModal(true)
                    dispatch(getCardsByUser())
                }
                else if(res?.type === "unFreezeVirtualCard/rejected"){
                    setIsOpen(false)   
                    setFreezeCardModal(true)
                }
           }) 
        }
        else {
            dispatch(freezeVirtualCard({
            cardId: activeCard.id
            })).then((res)=>{
                if(res?.type === "freezeVirtualCard/fulfilled"){
                    setIsOpen(false)
                    setIsOn(!isOn)
                    setFreezeCardSuccessModal(true)
                    dispatch(getCardsByUser())
                }
                else if(res?.type === "freezeVirtualCard/rejected"){
                    setIsOpen(false)   
                    setFreezeCardModal(true)
                }
            })
        }

        setTimeout(()=>{
            setIsOpen(false)
            setIsOn(!isOn)
        },3000)


      
    }

    const handleCreateCardProceed = () => {
        const MINIMUM_CREATION_AMOUNT = 2; // $2 USD minimum for card creation
        const selectedWallet = walletData.fiatWallets.find(wallet => 
            sourceWallet.includes(wallet.Currency.code)
        );
        const walletBalance = parseFloat(selectedWallet?.balance || 0);
        const receivedAmount = parseFloat(receiveAmount.replace(/,/g, '') || 0);
        const totalAmount = parseFloat(amount || 0);
    
        // Check minimum creation amount
        if (receivedAmount < MINIMUM_CREATION_AMOUNT) {
            setErrorMessage(`Minimum card creation amount is $${MINIMUM_CREATION_AMOUNT}`);
            return;
        }
    
        // Check wallet balance
        if (totalAmount > walletBalance) {
            setErrorMessage("Insufficient wallet balance");
            return;
        }
    
        setErrorMessage("");
        setIsInitiated(true);
    };


    const handleRequestCard = () => {
        setType("request");
        setCreateCardModal(false);
        setIsOpen(true);
      
        const initiateCardCreation = (wallets) => {
          const debitWalletId = wallets.find(
            item => item.Currency.code === sourceWallet
          )?.id;
      
          dispatch(createVirtualCard({
            brand: cardType,
            amount: parseFloat(receiveAmount.replace(/,/g, '')),
            debitWalletId: debitWalletId,
          })).then((res) => {
            if (res?.type === "createVirtualCard/fulfilled") {
              setIsOpen(false);
              setCardRequestedModal(true);
              dispatch(getCardsByUser());
              setIsInitiated(false);
            } else {
              setIsOpen(false);
              setCreateCardModal(true);
              setIsInitiated(false);
            }
          });
        };
      
        if (hasUSDWallet) {
          initiateCardCreation(walletData.fiatWallets);
        } else {
          dispatch(createWallet({ fiatWalletId: usdCurrencyId }))
            .then((res) => {
              if (res?.type === "createWallet/fulfilled") {
                // Refresh wallet list first
                dispatch(getWalletBalance()).then((res)=>{
                    if(res?.type === "getWalletBalance/fulfilled"){
                        // Use the refreshed wallet list to get wallet ID
                          const updatedWallets = res?.payload?.data?.fiatWallets || [];
                          initiateCardCreation(updatedWallets);
                  }
                })
              } else {
                setIsOpen(false);
                setCreateCardModal(true);
                setIsInitiated(false);
              }
            });
        }
    };
   

    const handleInitialProceed = () => {
        const MINIMUM_FUNDING_AMOUNT = 1; // 1 USD minimum
        const selectedWallet = walletData.fiatWallets.find(wallet => 
            sourceWallet.includes(wallet.Currency.code)
        );
        const walletBalance = parseFloat(selectedWallet?.balance || 0);
        const receivedAmount = parseFloat(receiveAmount.replace(/,/g, '') || 0);
        const totalAmount = parseFloat(amount || 0);
    
        // Check minimum funding amount
        if (receivedAmount < MINIMUM_FUNDING_AMOUNT) {
            setErrorMessage(`Minimum funding amount is $${MINIMUM_FUNDING_AMOUNT}`);
            return;
        }
    
        // Check wallet balance
        if (totalAmount > walletBalance) {
            setErrorMessage("Insufficient wallet balance");
            return;
        }
    
        setErrorMessage("");
        setIsInitiated(true);
    };

    const handleFundCard = () =>{
        setType("fund")
        setFundCardModal(false)
        setIsOpen(true)
        let debitWalletId = walletData.fiatWallets.find((item) => item.Currency.code === sourceWallet).id

        dispatch(fundVirtualCard({
            amount: parseFloat(receiveAmount.replace(/,/g, '')),
            cardId: activeCard.id,
            debitWalletId: debitWalletId
        })).then((res)=>{
            if(res?.type === "fundVirtualCard/fulfilled"){
                setIsOpen(false)
                dispatch(getCardsByUser())
                setIsInitiated(false)
                setVirtualFundingSuccessModal(true)
                resetFormValues();
            }
            else if(res?.type === "fundVirtualCard/rejected"){
                setIsOpen(false)
                setFundCardModal(true)
                setIsInitiated(false)
            }
        })
    }

    const handleWithdrawFromCard = () =>{
        const MINIMUM_WITHDRAWAL_AMOUNT = 5; // $5 USD minimum for withdrawal
        const cardBalance = card ? parseFloat(formatKoboToNaira(card.balance)) : 0;
        const withdrawAmount = parseFloat(amount || 0);
        const withdrawalFee = fees?.virtual_card_withdrawal_fee?.value?.data || 0;
        const totalWithdrawalAmount = withdrawAmount + withdrawalFee;
    
        // Check minimum withdrawal amount
        if (withdrawAmount < MINIMUM_WITHDRAWAL_AMOUNT) {
            setErrorMessage(`Minimum withdrawal amount is $${MINIMUM_WITHDRAWAL_AMOUNT}`);
            return;
        }
    
        // Check if card has sufficient balance
        if (totalWithdrawalAmount > cardBalance) {
            setErrorMessage("Insufficient card balance");
            return;
        }

           // Proceed with withdrawal if validations pass
        setErrorMessage("");
        setType("withdraw")
        setWithdrawModal(false)
        setIsOpen(true)
        setInitiateLoader(true)
        let creditWalletId = walletData.fiatWallets.find((item) => item.Currency.code === destinationWallet).id
        dispatch(withdrawFromVirtualCard({
            amount: parseFloat(amount),
            cardId: activeCard.id,
            creditWalletId: creditWalletId
        })).then((res)=>{
            if(res?.type === "withdrawFromVirtualCard/fulfilled"){
                setIsOpen(false)
                setWithdrawModal(false)
                dispatch(getCardsByUser())
                setInitiateLoader(false)
                setWithdrawSuccessModal(true)
                setIsInitiated(false)
                resetFormValues();
            }
            else if(res?.type === "withdrawFromVirtualCard/rejected"){
                setIsOpen(false)
                setWithdrawModal(true)
                setIsInitiated(false)
                setInitiateLoader(false)
            }
        })
    }


  const getMoreItemsByOffset = (page) => {
    setCurrentPage(page)
    dispatch(fetchCardTransactions({
      cardId: activeCard.id,
      page: page
    }))
  }


  useEffect(() => {
        dispatch(setHeader("Virtual Cards"));
        dispatch(fetchExchangeConfig())
        dispatch(fetchVirtualCardFees())
        dispatch(getWalletBalance());
    }, [dispatch]);

    useEffect(() => {
        if (fiatCurrencies.length > 0 && walletData?.fiatWallets.length > 0) {
          // Find the currency from the fiat list
          const usdCurrency = fiatCurrencies.find(currency => currency.code === "USD");
    
          if (usdCurrency) {
             setUsdCurrencyId(usdCurrency.id);
            // Now check if the user has a wallet with that currency ID
            const walletExists = walletData?.fiatWallets.some(
              wallet => wallet.Currency.id === usdCurrency.id
            );
    
            setHasUSDWallet(walletExists);
          } else {
            // USD currency isn't even in the fiat list
            setHasUSDWallet(false);
            setUsdCurrencyId(null);
          }
        }
      }, [fiatCurrencies, walletData]);

    useEffect(()=>{
        dispatch(getCardsByUser())
    },[dispatch])

    return ( 
        <>

        {/* ========= ==  ADD NEW VIRTUAL CARD MODAL */}
        <Modal
            canClose={true}
            modalOpen={isRequestCardModal}
            setModalOpen={setRequestCardModal}
            title='Add New Virtual Card'
            minWidth='35%'
        >

        {
            myLevel && myLevel.kyc_setting_id < 4
            ?
            (
            <div style={{marginTop: '30px'}}>
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                To create a virtual card, upgrade your account to level 4 verification for swift verification and 
                        additional priviledges
                    </p>
            </div>
                )
            :
            null
        }
        
        
            <div style={{marginTop: '20px'}}>
                {
                myLevel && myLevel.kyc_setting_id < 4
                    ?
                <button onClick={()=>handleUpgrade()} className={style.save} >
                    Upgrade to Level 4
                </button>
                :
                null
                }
            </div>
        

        </Modal>


           {/* ========= ==  FREEZE/UNFREEZE MY CARD MODAL */}
           <Modal
            canClose={true}
            modalOpen={isFreezeCardModal}
            setModalOpen={setFreezeCardModal}
            title={isOn ? 'Unfreeze My Card' : 'Freeze My Card'}
            minWidth='35%'
        >

            <div style={{marginTop: '30px'}}>
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                    {
                        isOn 
                        ?
                        "Unfreezing your card means payments will now be made on this card."
                        :
                        "Freezing your card means no payments will be made on this card. You can unfreeze at any time."
                    }
                    </p>
            </div>   

            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <button onClick={handleFreezeCard} style={{marginTop: '30px', maxWidth: '240px'}} className={style.save}>
                   {isOn ? 'Unfreeze Card' : 'Freeze Card'}
                </button>
                <button onClick={()=> setFreezeCardModal(false)} style={{maxWidth: '240px'}}  className={style.deactivateBtn}>
                    Cancel
                </button>
             </div>     
        </Modal>

        {/* ===== CREATE VIRTUAL CARD MODAL */}
         <Modal title='Create Virtual Card'  minWidth='40%' canClose modalOpen={isCreateCardModal} setModalOpen={handleCloseCreateCardModal}>

                    {!isInitiated
                    ?
                    <div style={{marginTop: '25px'}}>

                    
                     <div className={style.labelPut}>
                        <label htmlFor="cardType">Card Type</label>
                        <div className={style.select} style={{marginTop: '10px'}}>
                            <div id="cardType"
                            name="cardType" className={style.selectInput}>
                            <input
                                type="text"
                                value={cardType}
                                placeholder="Please select a card type"
                                style={{pointerEvents: "none"}}
                            />
                            <ArrowDown2
                                style={{
                                transform:
                                openCardType === true
                                    ? "translateY( -50%) rotate(-540deg)"
                                    : "translateY( -50%) rotate(0deg)",
                                pointerEvents: "none",
                                }}
                                className={style.dropDown}
                                size="20"
                                color="#909090"
                                variant="Bold"
                            />
                            </div>
                            <div
                            style={{
                                height: openCardType === true ? "fit-content" : "0px",
                            }}
                            className={style.option}
                            >
                            {cardTypes && cardTypes.length > 0 ? (
                                cardTypes.map((item, index) => (
                                <p
                                    id="cardTypeDrop"
                                    key={item.id}
                                    onClick={(e) => {
                                    setOpenCardType(false);
                                    setCardType(item.name);
                                    }}
                                    style={{
                                        borderBottom: `${index !== cardTypes.length - 1 ? '1px #90909042 solid': ''}`
                                    }}
                                >
                                  {item.name}
                                </p>
                                ))
                            ) : (
                                <p>{`Oops there is no card type found`}</p>
                            )}
                            </div>
                        </div>
                    </div>

                     <div
                         >
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <label htmlFor="from_wallet">Fund From</label>
                        {sourceWallet ? 
                        <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>Bal: {sourceWallet === "NGN" ? '₦' : sourceWallet === "GHS" ? '₵' : '$'}{walletData.fiatWallets.find(wallet => sourceWallet.includes(wallet.Currency.code)).balance}</p> : null}
                        </div>
                        <div className={style.select} style={{marginTop: '10px'}}>
                        <div id="from_wallet"
                            onClick={toggleFromWallet}
                            name="from_wallet" className={style.selectInput}>
                            <div className={style.walletDiv}>
                            {
                                sourceWallet 
                                &&
                                <img
                                style={{ width: "20px", height: '20px', borderRadius: '50%'}}
                                src={sourceWallet === "NGN" ? ng_icon:  sourceWallet === "GHS" ? ghana_icon : sourceWallet === "USD" ? us_icon: ""} alt="country icon" 
                                />
                                }
                                <p style={{fontWeight: `${sourceWallet ? 600: 400}`, marginBottom: '0px'}} className={style.walletTitle}>{sourceWallet ? sourceWallet : 'Select wallet'}</p>
                            </div>
                        
                            <ArrowDown2
                            style={{
                                transform:
                                openFromWallet === true
                                    ? "translateY( -50%) rotate(-540deg)"
                                    : "translateY( -50%) rotate(0deg)",
                                pointerEvents: "none",
                            }}
                            className={style.dropDown}
                            size="20"
                            color="#909090"
                            variant="Bold"
                            />
                        </div>
                        <div
                            style={{
                            height: openFromWallet === true ? "fit-content" : "0px",
                            }}
                            className={style.option}
                        >
                            {walletData ? (
                            walletData.fiatWallets.map((item, index) => (
                                <p
                                id={item.Currency.id}
                                key={item.id}
                                style={{
                                    borderBottom: walletData.fiatWallets.length - 1 === index ? "none" : "1px #90909039 solid;",
                                }} 
                                onClick={(e) => {
                                    handleFromWallet(e);
                                }}
                                >
                                {item.Currency.code}
                                </p>
                            ))
                            ) : (
                            <p>Sorry, no wallets here</p>
                            )}
                        </div>
                        </div>
                    </div>

                    <div className={style.labelPut} style={{marginTop: '15px', marginBottom: '0px'}}>
                            <label htmlFor="amount">Amount</label>
                            <div className={style.input}>
                            <input
                                type="number"
                                name="amount"
                                placeholder="Enter amount"
                                value={amount}
                                onChange={handleAmountChange}                 
                            />
                             {errorMessage && <p style={{ color: "#FF0000", fontSize: '12px', marginTop: '5px', textAlign:'left' }}>{errorMessage}</p>}
                            </div>
                    </div>

            

                    {exchangeRate && amount > 0 ? (
                        <div className={style.info_div}>
                            <img src={info_icon} alt="info icon" />
                            <p style={{margin: '0px', color: '#40196D'}}>
                            {(() => {
                                const display = formatExchangeRateDisplay(
                                exchangeRate, 
                                sourceWallet, 
                                destinationWallet
                                );
                                return `${display.baseAmount} ${display.from} = ${display.rate} ${display.to}`;
                            })()}
                            </p>
                        </div>
                        ) : null}

                  <div className={style.labelPut} style={{marginTop: '15px', marginBottom: '0px'}}>
                            <label htmlFor="receiveAmt">You'll receive</label>
                            <div className={style.input}>
                            <input
                                type="text"
                                name="receiveAmt"
                                placeholder="Enter amount"
                                value={`${destinationWallet} ${receiveAmount ? receiveAmount : 0}`}
                                disabled
                            />
                        </div>
                     </div>

                        <div className={style.info_div} style={{marginBottom: '20px'}}>
                         <img src={info_icon} alt="info icon" />
                            <p style={{margin: '0px', color: '#40196D'}}>Card Creation Fee: USD {
                                        (
                                            (fees?.virtual_card_issuing_fee?.value?.data || 0) + 
                                            (fees?.virtual_card_funding_fee?.value?.data || 0)
                                        ).toFixed(2)
                                    }</p>
                            </div>
                      

                        <>
                        <div style={{maxWidth: '300px', margin: 'auto', textAlign: 'center'}}>
                            <p style={{color: '#40196D', fontSize: 14, fontWeight: 400, marginBottom: '0px'}}>By creating your virtual card, you accept our <span style={{color: '#40196D', textDecoration: 'underline', fontWeight: 500, cursor: 'pointer'}}>Terms and Conditions</span></p>
                        </div>
                        <button 
                        disabled={amount <= 0 || !sourceWallet || !cardType}
                        onClick={handleCreateCardProceed}
                        style={{marginTop: '20px'}} className={style.save}>
                            Proceed
                            </button>
                       </>
                        

                    </div>
                    :
                    <div style={{marginTop: '20px'}}>

                    

                        <div  onClick={() => setIsInitiated(false)} style={{width: '20px', height: '20px', background: '#40196d1a', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}}>
                            <img src={arrow_left} alt="arrow left" />
                        </div>

                        <div style={{background: '#F5F3F7', marginTop: '20px',marginBottom: '20px', borderRadius: '20px', padding: '25px 25px'}}>
                            <p style={{color: '#212121', fontWeight: '400', textAlign: 'left', fontSize: 14, marginBottom: 0}}>Please check transaction details</p>

                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                    <img src={sourceWallet === "NGN" ? ng_icon : sourceWallet === "GHS" ? ghana_icon : us_icon} alt='us icon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Create Card From</h6>
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>{sourceWallet} Wallet</p>
                                </div>
                            </div>

                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                    <img src={transactionTypeIcon} alt='transactionTypeIcon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Transaction Type</h6>
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>Virtual Card Creation</p>
                                </div>
                            </div>


                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                    <img src={moneyIcon} alt='moneyIcon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Amount to be funded</h6>
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>${receiveAmount} </p>
                                </div>
                            </div>

                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                <img src={moneyIcon} alt='moneyIcon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Card Creation Fee</h6>
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>${ (fees?.virtual_card_issuing_fee?.value?.data || 0) +  (fees?.virtual_card_funding_fee?.value?.data || 0)}</p>
                                </div>
                            </div>

                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                <img src={moneyIcon} alt='moneyIcon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Total</h6>                                    
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}> 
                                    ${(
                                        parseFloat(receiveAmount) + 
                                        (fees?.virtual_card_issuing_fee?.value?.data || 0) + 
                                        (fees?.virtual_card_funding_fee?.value?.data || 0)
                                    ).toFixed(2)}
                                    </p>
                                </div>
                            </div>

                            {sourceWallet !== 'USD' &&
                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                    <img src={moneyIcon} alt='moneyIcon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Total in ({sourceWallet})</h6>
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                                        {sourceWallet === "NGN" ? '₦' : sourceWallet === "GHS" ? '₵' : '$'}
                                        {(
                                            (
                                                parseFloat(receiveAmount) + 
                                                (fees?.virtual_card_issuing_fee?.value?.data || 0) + 
                                                (fees?.virtual_card_funding_fee?.value?.data || 0)
                                            ) / exchangeRate
                                        ).toFixed(2)}
                                    </p>
                                </div>
                            </div>
                            }
                        </div>
                      
                      <>
                        {!hasUSDWallet &&
                         <div style={{ textAlign: 'center'}}>
                            <p style={{color: '#40196D', fontSize: 14, fontWeight: 400, marginBottom: '0px'}}>You'll need a USD wallet for this—we'll create one for you if you don't have it.</p>
                        </div>
                         }
                        <button onClick={handleRequestCard} style={{marginTop: '10px'}} className={style.save}>
                          Proceed
                        </button>
                       </>

                    </div>
                    }
         </Modal>

           {/* ===== FUND VIRTUAL CARD MODAL */}
         <Modal title='Fund Virtual Card'  minWidth='40%' canClose modalOpen={isFundCardModal} setModalOpen={handleCloseFundModal}>

                    {!isInitiated
                    ?
                    <div style={{marginTop: '25px'}}>

                     <div
                         >
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <label htmlFor="from_wallet">Fund From</label>
                        {sourceWallet ? 
                        <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>Bal: {sourceWallet === "NGN" ? '₦' : sourceWallet === "GHS" ? '₵' : '$'}{walletData.fiatWallets.find(wallet => sourceWallet.includes(wallet.Currency.code)).balance}</p> : null}
                        </div>
                        <div className={style.select} style={{marginTop: '10px'}}>
                        <div id="from_wallet"
                            onClick={toggleFromWallet}
                            name="from_wallet" className={style.selectInput}>
                            <div className={style.walletDiv}>
                            {
                                sourceWallet 
                                &&
                                <img
                                style={{ width: "20px", height: '20px', borderRadius: '50%'}}
                                src={sourceWallet === "NGN" ? ng_icon:  sourceWallet === "GHS" ? ghana_icon : sourceWallet === "USD" ? us_icon: ""} alt="country icon" 
                                />
                                }
                                <p style={{fontWeight: `${sourceWallet ? 600: 400}`, marginBottom: '0px'}} className={style.walletTitle}>{sourceWallet ? sourceWallet : 'Select wallet'}</p>
                            </div>
                        
                            <ArrowDown2
                            style={{
                                transform:
                                openFromWallet === true
                                    ? "translateY( -50%) rotate(-540deg)"
                                    : "translateY( -50%) rotate(0deg)",
                                pointerEvents: "none",
                            }}
                            className={style.dropDown}
                            size="20"
                            color="#909090"
                            variant="Bold"
                            />
                        </div>
                        <div
                            style={{
                            height: openFromWallet === true ? "fit-content" : "0px",
                            }}
                            className={style.option}
                        >
                            {walletData ? (
                            walletData.fiatWallets.map((item, index) => (
                                <p
                                id={item.Currency.id}
                                key={item.id}
                                style={{
                                    borderBottom: walletData.fiatWallets.length - 1 === index ? "none" : "1px #90909039 solid;",
                                }} 
                                onClick={(e) => {
                                    handleFromWallet(e);
                                }}
                                >
                                {item.Currency.code}
                                </p>
                            ))
                            ) : (
                            <p>Sorry, no wallets here</p>
                            )}
                        </div>
                        </div>
                    </div>

                    <div className={style.labelPut}  style={{marginTop: '15px', marginBottom: '0px'}}>
                        <label htmlFor="amount">Amount<span style={{color:'#FF0000'}}>*</span></label>
                        <div className={style.input}>
                        <input
                            type="number"
                            name="amount"
                            placeholder="Enter amount"
                            value={amount}
                            onChange={handleAmountChange} 
                        />
                         {errorMessage && <p style={{ color: "#FF0000", fontSize: '12px', marginTop: '5px', textAlign:'left', marginBottom: '0px' }}>{errorMessage}</p>}
                        </div>
                    </div>


                    {exchangeRate && amount > 0 ? (
                        <div className={style.info_div}>
                            <img src={info_icon} alt="info icon" />
                            <p style={{margin: '0px', color: '#40196D'}}>
                            {(() => {
                                const display = formatExchangeRateDisplay(
                                exchangeRate, 
                                sourceWallet, 
                                destinationWallet
                                );
                                return `${display.baseAmount} ${display.from} = ${display.rate} ${display.to}`;
                            })()}
                            </p>
                        </div>
                        ) : null}

                    <div className={style.labelPut} style={{marginTop: '15px', marginBottom: '0px'}}>
                            <label htmlFor="receiveAmt">You'll receive</label>
                            <div className={style.input}>
                            <input
                                type="text"
                                name="receiveAmt"
                                placeholder="Enter amount"
                                value={`${destinationWallet} ${receiveAmount ? receiveAmount : 0}`}
                                disabled
                            />
                        </div>
                     </div>

                    <div className={style.info_div} style={{marginBottom: '20px'}}>
                         <img src={info_icon} alt="info icon" />
                            <p style={{margin: '0px', color: '#40196D'}}>Processing Fee: USD {fees && fees.virtual_card_funding_fee ? fees?.virtual_card_funding_fee?.value?.data: 0}</p>
                        </div>

                       

                  
                    
                        <button disabled={amount <= 0 || !sourceWallet} onClick={handleInitialProceed} style={{marginTop: '30px'}} className={style.save}>
                            Proceed
                         </button>
                         

                    </div>
                    :
                    <div style={{marginTop: '20px'}}>



                        <div  onClick={() => setIsInitiated(false)} style={{width: '20px', height: '20px', background: '#40196d1a', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}}>
                            <img src={arrow_left} alt="arrow left" />
                        </div>

                        <div style={{background: '#F5F3F7', marginTop: '20px', borderRadius: '20px', padding: '25px 25px'}}>
                            <p style={{color: '#212121', fontWeight: '400', textAlign: 'left', fontSize: 14, marginBottom: 0}}>Please check transaction details</p>

                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                              <div>
                                    <img src={sourceWallet === "NGN" ? ng_icon : sourceWallet === "GHS" ? ghana_icon : us_icon} alt='us icon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Fund From</h6>
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>{sourceWallet} Wallet</p>
                                </div>
                            </div>

                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                    <img src={transactionTypeIcon} alt='transactionTypeIcon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Transaction Type</h6>
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>Virtual Card Funding</p>
                                </div>
                            </div>


                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                    <img src={moneyIcon} alt='moneyIcon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Amount to be funded</h6>
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>${receiveAmount}</p>
                                </div>
                            </div>

                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                <img src={moneyIcon} alt='moneyIcon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Processing Fee</h6>
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>${fees && fees.virtual_card_funding_fee ? fees?.virtual_card_funding_fee?.value?.data: 0}</p>
                                </div>
                            </div>

                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                    <img src={moneyIcon} alt='moneyIcon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Total</h6>
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>${(parseFloat(receiveAmount) + (fees && fees.virtual_card_funding_fee ? fees?.virtual_card_funding_fee?.value?.data: 0)).toFixed(2)}</p>
                                </div>
                            </div>

                           {sourceWallet !== 'USD' &&
                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                    <img src={moneyIcon} alt='moneyIcon' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Total in ({sourceWallet})</h6>
                                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                                        {sourceWallet === "NGN" ? '₦' : sourceWallet === "GHS" ? '₵' : '$'}
                                       {((parseFloat(receiveAmount) + (fees && fees.virtual_card_funding_fee ? fees?.virtual_card_funding_fee?.value?.data : 0)) / exchangeRate).toFixed(2)}
                                    </p>
                                </div>
                            </div>
                            }

                       
                        </div>
                    
                        <button onClick={handleFundCard} style={{marginTop: '30px'}} className={style.save}>
                        Proceed
                        </button>

                    </div>
                    }
         </Modal>

           {/* ===== WithdRAW CARD MODAL */}
           <Modal title='Withdraw'  minWidth='40%' canClose modalOpen={isWithdrawModal} setModalOpen={handleCloseWithdrawModal}>
            <div style={{marginTop: '25px'}}>

                <div className={style.labelPut}>
                  <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <label htmlFor="cardType">From</label>
                    <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>Bal: ${(card && card.balance ? formatKoboToNaira(card.balance) : '0.00')}</p>
                    </div>
                    <div className={style.cardTypeDiv}>
                        <img
                        style={{ width: "20px", height: '20px', borderRadius: '50%'}}
                        src={us_icon} alt="country icon" 
                        /> 
                        <p style={{marginBottom: '0px'}}>{activeCard ? activeCard.masked_pan: ''}</p>
                    </div>
                </div>

                
                    <div  style={{marginTop: '15px'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <label htmlFor="to_wallet">To</label>
                        {destinationWallet ? 
                            <p style={{ margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14 }}>
                            Bal: {destinationWallet === "NGN" ? '₦' : destinationWallet === "GHS" ? '₵' : '$'}
                            {
                            walletData?.fiatWallets.find(wallet => destinationWallet.includes(wallet.Currency.code))?.balance ?? "0.00"
                            }
                        </p> : null}
                        </div>
                        <div className={style.select} style={{marginTop: '10px'}}>
                        <div id="to_wallet"
                            onClick={toggleToWallet}
                            name="to_wallet" className={style.selectInput}>
                            <div className={style.walletDiv}>
                            {
                                destinationWallet 
                                &&
                                <img
                                style={{ width: "20px", height: '20px', borderRadius: '50%'}}
                                src={destinationWallet === "NGN" ? ng_icon:  destinationWallet === "GHS" ? ghana_icon : destinationWallet === "USD" ? us_icon: ""} alt="country icon" 
                                />
                                }
                                <p style={{fontWeight: `${destinationWallet ? 600: 400}`, marginBottom: '0px'}} className={style.walletTitle}>{destinationWallet ? destinationWallet : 'Select wallet'}</p>
                            </div>
                        
                            <ArrowDown2
                            style={{
                                transform:
                                openToWallet === true
                                    ? "translateY( -50%) rotate(-540deg)"
                                    : "translateY( -50%) rotate(0deg)",
                                pointerEvents: "none",
                            }}
                            className={style.dropDown}
                            size="20"
                            color="#909090"
                            variant="Bold"
                            />
                        </div>
                        <div
                            style={{
                            height: openToWallet === true ? "fit-content" : "0px",
                            }}
                            className={style.option}
                        >
                            {walletData ? (
                            walletData.fiatWallets.map((item, index) => (
                                <p
                                id={item.Currency.id}
                                key={item.id}
                                style={{
                                    borderBottom: walletData.fiatWallets.length - 1 === index ? "none" : "1px #90909039 solid;",
                                }} 
                                onClick={(e) => {
                                    handleToWallet(e);
                                }}
                                >
                                {item.Currency.code}
                                </p>
                            ))
                            ) : (
                            <p>Sorry, no wallets here</p>
                            )}
                        </div>
                        </div>
                    </div>

                    <div className={style.labelPut}  style={{marginTop: '15px', marginBottom: '0px'}}>
                            <label htmlFor="amount">Amount<span style={{color:'#FF0000'}}>*</span></label>
                            <div className={style.input}>
                            <input
                                type="number"
                                name="amount"
                                placeholder="Enter amount"
                                value={amount}
                                onChange={handleWithdrawAmountChange} 
                            />
                            {errorMessage && <p style={{ color: "#FF0000", fontSize: '12px', marginTop: '5px', textAlign:'left', marginBottom: '0px' }}>{errorMessage}</p>}
                            </div>
                    </div>

                   
                    {exchangeRate && amount > 0 ? (
                        <div className={style.info_div}>
                            <img src={info_icon} alt="info icon" />
                            <p style={{margin: '0px', color: '#40196D'}}>
                            {(() => {
                                const display = formatExchangeRateDisplay(
                                exchangeRate, 
                                sourceWallet, 
                                destinationWallet
                                );
                                return `${display.baseAmount} ${display.from} = ${display.rate} ${display.to}`;
                            })()}
                            </p>
                        </div>
                        ) : null}

                    <div className={style.labelPut} style={{marginTop: '15px', marginBottom: '0px'}}>
                            <label htmlFor="receiveAmt">You'll receive</label>
                            <div className={style.input}>
                            <input
                                type="text"
                                name="receiveAmt"
                                placeholder="Enter amount"
                                value={`${destinationWallet} ${receiveAmount ? receiveAmount : 0}`}
                                disabled
                            />
                        </div>
                     </div>

                    <div className={style.info_div} style={{marginBottom: '20px'}}>
                         <img src={info_icon} alt="info icon" />
                            <p style={{margin: '0px', color: '#40196D'}}>Processing Fee: USD {fees && fees.virtual_card_withdrawal_fee ? fees?.virtual_card_withdrawal_fee?.value?.data: 0}</p>
                        </div>

            {initiateLoader === true ? (
            <div  style={{marginTop: '50px'}} className={style.lottieWrap}>
                <Lottie
                style={{
                    width: "70px",
                    height: "70px",
                    color: "#fff",
                    padding: "0px",
                    margin: "0px",
                }}
                animationData={loader}
                loop={true}
                />
            </div>
                ) : (
                <>
           
                <button
                disabled={amount <= 0 || !destinationWallet}
                 onClick={handleWithdrawFromCard} style={{marginTop: '20px'}} className={style.save}>
                    Withdraw
                    </button>
                    </>
                    )
                }

            </div>
        </Modal>

      {/* =========================== THE LOADING MODAL TO REQUEST VIRTUAL CARD  */}
        <Modal
        canClose={false}
        modalOpen={isOpen}
        setModalOpen={setIsOpen}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={spin_circle} alt="spin circle" className={style.animate_spin} />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>
                    {formatLoaderTitle(type)}
                 </h4>
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                  Please wait...
                </p>
               
            </div>
        </div>

        </Modal>

        {/* ======== THE MODAL TO STATE THAT VIRTUAL CARD HAS BEEN REQUESTED */}
        <Modal
        canClose={true}
        modalOpen={isCardRequestedModal}
        setModalOpen={setCardRequestedModal}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={successIcon} alt="spin circle" />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>Virtual Card Requested</h4>
            
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                We are currently processing your card and would soon send it on it’s way to you. 
                </p>
            </div>

            <button onClick={() => setCardRequestedModal(false)} style={{marginTop: '20px'}} className={style.save}>
               Continue
            </button>

        </div>

        </Modal>

           {/* ======== THE MODAL TO STATE THAT VIRTUAL CARD HAS BEEN FUNDED */}
           <Modal
        canClose={true}
        modalOpen={isVirtualFundingSuccessModal}
        setModalOpen={setVirtualFundingSuccessModal}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={successIcon} alt="spin circle" />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>Virtual Card Funding</h4>
            
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                Your card funding  was successful
                </p>
            </div>

            <button onClick={() => setVirtualFundingSuccessModal(false)} style={{marginTop: '20px'}} className={style.save}>
               Ok
            </button>

        </div>

          </Modal>

               {/* ======== THE MODAL TO STATE THAT WITHDRAWAL IS SUCCESSFUL */}
               <Modal
        canClose={true}
        modalOpen={isWithdrawSuccessModal}
        setModalOpen={setWithdrawSuccessModal}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={successIcon} alt="spin circle" />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>Withdrawal Successful</h4>
            
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                Your wallet has been credited successfully.
                </p>
            </div>

            <button onClick={() => setWithdrawSuccessModal(false)} style={{marginTop: '20px'}} className={style.save}>
               Ok
            </button>

        </div>

          </Modal>

           {/* ======== THE MODAL TO STATE THAT VIRTUAL CARD HAS BEEN FREEZED/UNFREEZED */}
           <Modal
        canClose={true}
        modalOpen={isFreezeCardSuccessModal}
        setModalOpen={setFreezeCardSuccessModal}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={isOn ? lock_icon : successIcon } alt="lock_icon" />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>
                    {isOn ? 'Card Freezed': "Card Unfrozen"}
                </h4>
            
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
               {
                isOn ?
                "Your virtual card has been locked, and cannot be used for transactions until you unlock it.. "
                :
                "Your virtual card has been unlocked, and can now be used for transactions"
               }
                 </p>
            </div>

            <button onClick={() => setFreezeCardSuccessModal(false)} style={{marginTop: '20px'}} className={style.save}>
               Ok
            </button>

        </div>

        </Modal>



        {isLoading ? (
            // Show loader while fetching cards
            <div style={{marginTop: '40px'}} className={style.lottieWrap}>
                <Lottie
                style={{
                    width: "70px",
                    height: "70px",
                    color: "#fff",
                    padding: "0px",
                    margin: "0px",
                }}
                animationData={loader}
                loop={true}
                />
          </div>
            ) : (
             <>
         {(!cards || cards.length === 0) ? (
            <div className={style.emptyVCDiv}>
                <div>
                    <img src={emptyVCImg} alt="empty virtual card icon" />
                </div>

                <div style={{marginTop:'30px'}}>
                    <p>You have no Existing virtual card
                    Add New Card</p>
                </div>

                <div>
                    <button onClick={handleRequestCheck} style={{marginTop: '30px'}} className={style.save}>
                        <img src={addCircleIcon} alt="add circle icon" />
                      Request Virtual Card
                    </button>
                </div>
            </div>
          ) : (
            <>
            <div className={style.cardLayoutWrapper}>
                {userCards.map((cardItem, index) => {
                    const positionClass = getCardPositionClass(index);
                    const isCenter = positionClass === 'center';

                    const isFlipped = flippedCardId === cardItem.id;

                    return (
                    <div
                        key={cardItem.id}
                        className={`${style.cardContainer} ${style[positionClass]} ${cardItem.status === "DISABLED" ? style.cardDisabled : ''}`}
                        onClick={() => handleCardClick(index)}
          
                    >
                        <div className={`${style.card} ${isCenter && isFlipped ? style.cardFlipped : ''}`}>
                        {/* Card Front */}
                        <div className={style.cardFront}>
                            <div className={style.cardLogo}>
                            <img src={logo} alt="logo" style={{width: '116px'}} />
                            </div>
                            <div className={style.currencyIndicator}>{cardItem.currency}</div>
                            {cardItem.status === "DISABLED" ? (
                          <div className={style.frozenText}>Card Frozen</div>
                                ) : (
                             <div className={style.cardFooter}>
                            <div className={style.cardholderInfo}>
                                <div className={style.cardholderName}>{cardItem.name}</div>
                                <div className={style.cardNumber}>{cardItem.masked_pan}</div>
                            </div>
                            <img src={cardItem.issuer === "MASTERCARD" ? mastercard_icon : visa_icon}  alt="card icon" className={style.masterCardLogo} />
                            </div>
                           )}

                            {isCenter && (
                            <button className={style.showDetailBtn} onClick={(e) => {
                                e.stopPropagation(); // Prevent repositioning card
                                toggleFlip(cardItem.id);
                            }}>
                                Show detail
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </button>
                            )}
                        </div>

                        {/* Card Back */}
                        <div className={style.cardBack}>
                            <div className={style.cardLogo}>
                            <img src={logo} alt="logo" style={{width: '100px'}} />
                            </div>
                            <div className={style.currencyIndicator}>{card.currency}</div>

                            <div>
                            <div className={style.cardDisplayNumber}>{card.card_number}</div>
                            </div>

                            <div className={style.cardBackFooter}>
                            <div className={style.cardholderInfo}>
                                <div className={style.cardholderName}>Expiry Date</div>
                                <div className={style.cardNumber}>{card.expiry}</div>
                            </div>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <div>
                                <div className={style.cardholderName}>CVC</div>
                                <div className={style.cardNumber}>{card.cvv}</div>
                                </div>
                                <div className={style.securityBadge}></div>
                            </div>
                            </div>

                              {/* Add Billing Address section */}
                            <div className={style.billingAddress}>
                                <div className={style.cardholderName}>Billing Address</div>
                                <div className={style.addressDetails}>
                                {card.address ? (
                                    <>
                                        {card.address.street} {card.address.city}, {card.address.state} {card.address.postal_code} {card.address.country}
                                    </>
                                ) : 'Not available'}
                                </div>
                            </div>

                            {isCenter && (
                            <button className={style.showDetailBtn} onClick={(e) => {
                                e.stopPropagation();
                                toggleFlip(cardItem.id);
                            }}>
                                Hide detail
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </button>
                            )}
                        </div>
                        </div>
                    </div>
                    );
                })}
                 {cards.length < 3 && (
                 <div onClick={handleRequestCheck} className={style.addCardContainer}>
                     <button className={style.addCardButton}>
                       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                         <path d="M12 5v14M5 12h14"></path>
                       </svg>
                     </button>
                     <p className={style.addCardText}>Add New Card</p>
                   </div>
                )}
            </div>

             <div className={style.cardBalDiv}>
                <h5>Card Balance</h5>
                <div className={style.balanceChecker}>
                    <h6>USD {visible ? (card && card.balance ? formatKoboToNaira(card.balance) : '0.00') : '******'}</h6>
                    <img src={eye_icon} 
                    alt="eye icon" style={{cursor: 'pointer'}}
                    onClick={() => setVisible(!visible)}
                     />
                </div>
              </div>

              <div className={style.cardActions}>
                    {/* Fund Card CTA */}
                    <div 
                      onClick={() => setFundCardModal(true)} 
                      className={card.status === "DISABLED" ? style.actionsDisabled : ''}
                       >
                        <div className={style.cardActionsDiv}>
                             <Receive size="20" color="#ffffff" variant="Outline" />
                        </div>
                        <div style={{textAlign: 'center', marginTop: '8px'}}>
                            <p style={{fontSize: 12, fontWeight: 400, color: '#40196D'}}>Fund Card</p>
                        </div>
                    </div>

                    {/* Withdraw CTA */}
                    <div
                     onClick={() => setWithdrawModal(true)}
                     className={card.status === "DISABLED" ? style.actionsDisabled : ''}
                     >
                        <div className={style.cardActionsDiv}>
                        <WalletAdd size="20" color="#ffffff" variant="Outline" />
                        </div>
                        <div style={{textAlign: 'center', marginTop: '8px'}}>
                            <p style={{fontSize: 12, fontWeight: 400, color: '#40196D'}}>Withdraw</p>
                        </div>
                    </div>

                    {/* Transactions CTA */}
                    <div onClick={scrollToTransactions}>
                         <div className={style.cardActionsDiv}>
                         <WalletAdd1 size="20" color="#ffffff" variant="Outline" />
                         </div>
                        <div style={{textAlign: 'center', marginTop: '8px'}}>
                            <p style={{fontSize: 12, fontWeight: 400, color: '#40196D'}}>Transactions</p>
                        </div>
                    </div>

              </div>

             <div className={style.cyptoBankDiv}>
                <div>
                    <h6 className={style.title}>Freeze Card</h6>
                    <p className={style.subtitle}>
                    Freezing your card means no payments will be made on this card. You can unfreeze at any time.</p>
                </div>
                <div>
                  {/* i need a switch here to toggle on and off */}
                  <div
                        className={`${style.toggle} ${isOn ? style.on : ''}`}
                        onClick={() => handleFreezeModal()}
                        >
                        <div className={style.circle} />
                 </div>
                  
                </div>
            </div>

            <div className={style.transactionsTable} ref={transactionsRef}>
            <h5>Card Transactions</h5>
            
                {transactions && transactions.length > 0 ? (
                    <div className={style.table}>
                    <table>
                        <thead>
                        <tr>
                            <th>
                            <div className={style.tableHead}>
                                <h5>Currency</h5>
                                <Icon
                                className={style.arrowCon}
                                icon="ph:arrows-down-up-fill"
                                />
                            </div>
                            </th>
                            <th>
                            <div className={style.tableHead}>
                                <h5>Description</h5>
                                <Icon
                                className={style.arrowCon}
                                icon="ph:arrows-down-up-fill"
                                />
                            </div>
                            </th>
                            <th>
                            <div className={style.tableHead}>
                                <h5>Status</h5>
                                <Icon
                                className={style.arrowCon}
                                icon="ph:arrows-down-up-fill"
                                />
                            </div>
                            </th>
                            <th>
                            <div className={style.tableHead}>
                                <h5>Amount</h5>
                                <Icon
                                className={style.arrowCon}
                                icon="ph:arrows-down-up-fill"
                                />
                            </div>
                            </th>
                            <th>
                            <div className={style.tableHead}>
                                <h5>Date</h5>
                                <Icon
                                className={style.arrowCon}
                                icon="ph:arrows-down-up-fill"
                                />
                            </div>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {transactions.map((transaction) => (
                            <tr key={transaction.id} className={style.fullRow}>
                            <td>
                                <div className={style.name}>
                                <h6>{transaction.currency}</h6>
                                </div>
                            </td>
                            <td>
                                <div className={style.name}>
                                <h6>{transaction.description}</h6>
                                </div>
                            </td>
                            <td>
                                {transaction.status === "SUCCESS" && (
                                <p className={style.success}>Success</p>
                                )}
                                {transaction.status === "CREDIT" && (
                                <p className={style.success}>Success</p>
                                )}
                                {transaction.status === "PENDING" && (
                                <p className={style.pending}>Pending</p>
                                )}
                                {transaction.status === "FAILED" && (
                                <p className={style.failed}>Failed</p>
                                )}
                            </td>
                            <td>
                                <h6 className={style.amount}>
                                {transaction.entry === "CREDIT" ? "+" : "-"}
                                {new Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency: transaction.currency,
                                }).format(formatKoboToNaira(transaction.amount))}
                                </h6>
                            </td>
                            <td>
                                <div className={style.date}>
                                <h6>
                                    {moment(transaction.created_at).format("Do, MMM YYYY")}
                                </h6>
                                <p>
                                    at {moment(transaction.created_at).format("hh:mm:ss a")}
                                </p>
                                </div>
                            </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>
                ) : (
                    <div className={style.emptyTransactions}>
                    <p>No transactions found</p>
                    </div>
                )}

                 {transactions.length > 0 &&
                  <div style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
                    <Pagination
                    currentPage={currentPage}
                    totalCount={transactionsTotal}
                    pageSize={PageSize}
                    onPageChange={(page) => getMoreItemsByOffset(page)}
                    />
                </div>
                }
            </div>
          </>
        )}
        </>
        )}
     </>
     );
}
 
export default VirtualCardsPage;